import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

// --- Servicios para Consumibles ---

export const createConsumable = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/consumables/create`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating consumable:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getConsumables = async (filters) => {
  try {
    const { page, limit, query } = filters;
    const offset = (page - 1) * limit;
    const response = await axios.post(`${API_URL}/consumables/filter`, {
      limit,
      offset,
      query
    }, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching consumables:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const updateConsumable = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/consumables/update/${id}`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating consumable:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const deleteConsumable = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/consumables/delete/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error deleting consumable:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const exportConsumables = async (query = {}) => {
  try {
    const response = await axios.post(`${API_URL}/consumables/export`, 
      { query }, 
      getAuthHeaders()
    );
    
    // El backend devuelve JSON con estructura { data: [], totalRecords: number }
    // Retornamos los datos para que ExportExcelButton los procese
    return response.data.data || [];
  } catch (error) {
    console.error('Error exporting consumables:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};
